function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import createIntlWithLocale from '../../internal/createIntlWithLocale';
import { handleReactIntlError } from '../../internal/errors/handleReactIntlError/handleReactIntlError';
import mergeOptions from '../../internal/mergeOptions';
import fixNegativeZero from '../../internal/number-formatter/fixNegativeZero';
import fixRounding from '../../internal/number-formatter/fixRounding';
import resolveFinalNotation from '../../internal/resolveFinalNotation';
/**
 * @see https://sail.stripe.me/apis/intl/useIntl#format-number
 */ export default function formatNumber(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, reports, analytics, /** The number to be formatted. */ number, /** An object with options to customize the formatting. */ options) {
    const resolvedNotation = resolveFinalNotation(options === null || options === void 0 ? void 0 : options.forceCompactAboveValue, number, options === null || options === void 0 ? void 0 : options.notation);
    const defaults = _object_spread({
        locale: config.locale,
        maximumFractionDigits: 3
    }, resolvedNotation === 'compact' ? {
        maximumSignificantDigits: 3
    } : {});
    const optionsWithDefaults = mergeOptions(config, defaults, reports, options, {
        style: 'decimal',
        notation: resolvedNotation
    });
    let consolidatedNumber;
    consolidatedNumber = fixNegativeZero(number);
    consolidatedNumber = fixRounding(consolidatedNumber, optionsWithDefaults.maximumFractionDigits, optionsWithDefaults.roundingMode);
    const intl = createIntlWithLocale(optionsWithDefaults.locale, config, reports, analytics);
    try {
        return intl.formatNumber(consolidatedNumber, optionsWithDefaults);
    } catch (error) {
        handleReactIntlError(reports, analytics, config.locale, error);
        return '';
    }
}

//# sourceMappingURL=formatNumber.js.map